:host {
  display: block;
}

.cms-modal-overlay {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgb(0 0 0 / 50%);
  transition: opacity 0.5s, visibility 0s 0.5s;
  display: flex;
  align-items: start;
  justify-content: center;
  padding: 0;
  border: 0;
}

.is-visible {
  opacity: 1;
  z-index: 1000;
  visibility: visible;
  transition: opacity 0.5s;
}

.cms-modal-inner {
  background: var(--cms-semanticColors-container-weak-background);
  margin-top: 8.375rem;
  max-width: 80%;
  position: relative;
  padding: var(--cms-spacing-100) var(--cms-spacing-100) var(--cms-spacing-200) var(--cms-spacing-100);
  font-family: var(--cms-base-font);
}

.cms-modal-headline-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-bottom: var(--cms-spacing-100);
}

.cms-modal-headline-wrapper:has(cms-headline) {
  justify-content: space-between;
}

.cms-modal-close {
  color: var(--cms-semanticColors-base-strong-text);
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: var(--cms-font-trade-gothic);
  font-size: 1rem;
}

.cms-modal-content {
  display: flex;
  flex-direction: column;
}

.cms-modal-content img {
  max-width: 100%;
  height: auto;
}
